<script setup>
import { defineProps, computed } from 'vue';

const props = defineProps({
    href: Object|String,
    text: String,
    locale: {
        type: String,
        default: "",
    }
});

import { usePage } from '@inertiajs/vue3'
const page = usePage();
const isHidden = computed(() => {
    return props.locale && props.locale !== page.props.locale;
});

import { Link } from '@inertiajs/vue3'
import {useRouting} from "@/composables/routing.js";
const {href} = useRouting();
</script>

<template>
    <li v-if=" ! isHidden" class="mt-1">
        <Link class="text-gray-600 hover:text-gray-800"
              :href="href(props.href)"
        >{{ $t(text) }}</Link>
    </li>
</template>
